// BEGIN::Added.by.HJSeo.2026.06.19.
export default {
  'insprpt.period.daily': {
    ko: 'Daily',
    ja: 'Daily',
    en: 'Daily',
    cn: '',
  },
  'insprpt.period.weekly': {
    ko: 'Weekly',
    ja: 'Weekly',
    en: 'Weekly',
    cn: '',
  },
  'insprpt.period.monthly': {
    ko: 'Monthly',
    ja: 'Monthly',
    en: 'Monthly',
    cn: '',
  },
  'insprpt.period.quarterly': {
    ko: 'Quarterly',
    ja: 'Quarterly',
    en: 'Quarterly',
    cn: '',
  },
  'insprpt.period.annual': {
    ko: 'Annual',
    ja: 'Annual',
    en: 'Annual',
    cn: '',
  },
  'insprpt.col.category': {
    ko: 'Category',
    ja: 'カテゴリ',
    en: 'Category',
    cn: '',
  },
  'insprpt.col.checkitem': {
    ko: 'Check items',
    ja: '点検項目',
    en: 'Check items',
    cn: '',
  },
  'insprpt.col.detail': {
    ko: 'Detail',
    ja: '詳細',
    en: 'Detail',
    cn: '',
  },
  'insprpt.col.status': {
    ko: 'Status',
    ja: 'ステータス',
    en: 'Status',
    cn: '',
  },
  'insprpt.btn.excel': {
    ko: 'Excel',
    ja: 'Excel',
    en: 'Excel',
    cn: '',
  },
  'insprpt.btn.check': {
    ko: '점검',
    ja: '点検',
    en: 'Check',
    cn: '',
  },
  // 리포트 이메일 수신자 설정 팝업
  'insprpt.rcpt.title': {
    ko: '체크리스트 수신자 설정',
    ja: 'チェックリスト受信者設定',
    en: 'Checklist recipients',
    cn: '',
  },
  'insprpt.rcpt.userid': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
    cn: '',
  },
  'insprpt.rcpt.receive': {
    ko: '수신',
    ja: '受信',
    en: 'Receive',
    cn: '',
  },
  'insprpt.rcpt.empty': {
    ko: '등록된 사용자가 없습니다.',
    ja: '登録されたユーザーがありません。',
    en: 'No registered users.',
    cn: '',
  },
  'insprpt.rcpt.saved': {
    ko: '수신자를 저장했습니다.',
    ja: '受信者を保存しました。',
    en: 'Recipients saved.',
    cn: '',
  },
  'insprpt.rcpt.savefail': {
    ko: '수신자 저장에 실패했습니다.',
    ja: '受信者の保存に失敗しました。',
    en: 'Failed to save recipients.',
    cn: '',
  },
  'insprpt.rcpt.loadfail': {
    ko: '수신자 목록을 불러오지 못했습니다.',
    ja: '受信者リストの読み込みに失敗しました。',
    en: 'Failed to load recipients.',
    cn: '',
  },
  // Detail 표시 방식 전환 토글(그리드 ↔ 건별 행)
  // BEGIN::Added.by.HJSeo.2026.08.25. 리포트 상단 조회기간 라벨.
  'insprpt.label.period': {
    ko: '조회기간',
    ja: '照会期間',
    en: 'Period',
    cn: '',
  },
  // FINISH::Added.by.HJSeo.2026.08.25.
  'insprpt.view.table': {
    ko: '그리드로 보기',
    ja: 'グリッド表示',
    en: 'Grid view',
    cn: '',
  },
  'insprpt.view.rows': {
    ko: '건별 행으로 보기',
    ja: '件別行表示',
    en: 'Row view',
    cn: '',
  },
  'insprpt.collect.history': {
    ko: '수집 이력',
    ja: '収集履歴',
    en: 'Collection history',
    cn: '',
  },
  // detail_data 의 label_cd → 표시 라벨 (RFC 항목별로 추후 확장)
  'insprpt.label.RPT_SERVER_NAME': {
    ko: 'Server Name',
    ja: 'Server Name',
    en: 'Server Name',
    cn: '',
  },
  'insprpt.label.RPT_HOST_NAME': {
    ko: 'Host Name',
    ja: 'Host Name',
    en: 'Host Name',
    cn: '',
  },
  'insprpt.label.RPT_SERVER': {
    ko: 'Server',
    ja: 'Server',
    en: 'Server',
    cn: '',
  },
  'insprpt.label.RPT_STATUS': {
    ko: 'Status',
    ja: 'Status',
    en: 'Status',
    cn: '',
  },
  'insprpt.label.RPT_DEADLOCK_CNT': {
    ko: 'Deadlock 건수',
    ja: 'Deadlock 件数',
    en: 'Deadlock count',
    cn: '',
  },
  'insprpt.label.RPT_LOCK_TABLE': {
    ko: 'Lock Table',
    ja: 'Lock Table',
    en: 'Lock Table',
    cn: '',
  },
  'insprpt.label.RPT_INSTANCE': {
    ko: 'Instance',
    ja: 'Instance',
    en: 'Instance',
    cn: '',
  },
  'insprpt.label.RPT_WP_TOTAL': {
    ko: 'WP 전체',
    ja: 'WP 合計',
    en: 'WP Total',
    cn: '',
  },
  'insprpt.label.RPT_WP_RUNNING': {
    ko: 'Running',
    ja: 'Running',
    en: 'Running',
    cn: '',
  },
  'insprpt.label.RPT_WP_WAITING': {
    ko: 'Waiting',
    ja: 'Waiting',
    en: 'Waiting',
    cn: '',
  },
  'insprpt.label.RPT_WP_STOPPED': {
    ko: 'Stopped/Shutdown',
    ja: 'Stopped/Shutdown',
    en: 'Stopped/Shutdown',
    cn: '',
  },
  'insprpt.label.RPT_UPD_CLIENT': {
    ko: 'Client',
    ja: 'Client',
    en: 'Client',
    cn: '',
  },
  'insprpt.label.RPT_UPD_USER': {
    ko: 'User',
    ja: 'User',
    en: 'User',
    cn: '',
  },
  'insprpt.label.RPT_UPD_DATE': {
    ko: '일시',
    ja: '日時',
    en: 'Date/Time',
    cn: '',
  },
  'insprpt.label.RPT_UPD_TCODE': {
    ko: 'T-Code',
    ja: 'T-Code',
    en: 'T-Code',
    cn: '',
  },
  'insprpt.label.RPT_UPD_ERROR_CNT': {
    ko: '오류 건수',
    ja: 'エラー件数',
    en: 'Error count',
    cn: '',
  },
  'insprpt.label.RPT_BTC_TOTAL': {
    ko: 'Total Jobs',
    ja: 'Total Jobs',
    en: 'Total Jobs',
    cn: '',
  },
  'insprpt.label.RPT_BTC_FINISHED': {
    ko: 'Finished',
    ja: 'Finished',
    en: 'Finished',
    cn: '',
  },
  'insprpt.label.RPT_BTC_CANCELED': {
    ko: 'Canceled',
    ja: 'Canceled',
    en: 'Canceled',
    cn: '',
  },
  // BEGIN::Added.by.HJSeo.2026.07.02. LEM 고객사 배치잡 오류 상세 라벨
  'insprpt.label.RPT_BTC_JOBNAME': {
    ko: '작업명',
    ja: 'ジョブ名',
    en: 'Job name',
    cn: '',
  },
  'insprpt.label.RPT_BTC_STATUS': {
    ko: '상태',
    ja: '状態',
    en: 'Status',
    cn: '',
  },
  'insprpt.label.RPT_BTC_STARTDATE': {
    ko: '시작일',
    ja: '開始日',
    en: 'Start date',
    cn: '',
  },
  'insprpt.label.RPT_BTC_DURATION': {
    ko: '기간(초)',
    ja: '期間(秒)',
    en: 'Duration(s)',
    cn: '',
  },
  'insprpt.label.RPT_BTC_MORE': {
    ko: '외 (표시 상한 초과)',
    ja: 'ほか (表示上限超過)',
    en: 'more (limit exceeded)',
    cn: '',
  },
  'insprpt.label.RPT_APMEM_EXT': {
    ko: '사용률',
    ja: '使用率',
    en: 'Usage',
    cn: '',
  },
  // 작업프로세스 확인(SM66) 상세 라벨 — raw_workprcs
  'insprpt.label.RPT_WP66_CNT': {
    ko: '실행중 WP 수',
    ja: '実行中WP数',
    en: 'Running WP count',
    cn: '',
  },
  'insprpt.label.RPT_WP66_NO': {
    ko: 'WP 번호',
    ja: 'WP番号',
    en: 'WP number',
    cn: '',
  },
  'insprpt.label.RPT_WP66_TYPE': {
    ko: '유형',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_WP66_PID': {
    ko: '프로세스 ID',
    ja: 'プロセスID',
    en: 'PID',
    cn: '',
  },
  'insprpt.label.RPT_WP66_STATUS': {
    ko: 'WP 상태',
    ja: 'WP状態',
    en: 'Status',
    cn: '',
  },
  'insprpt.label.RPT_WP66_REASON': {
    ko: '보류 정보',
    ja: '保留情報',
    en: 'Reason',
    cn: '',
  },
  'insprpt.label.RPT_WP66_SEM': {
    ko: '잠긴 세마포어',
    ja: 'セマフォ',
    en: 'Semaphore',
    cn: '',
  },
  'insprpt.label.RPT_WP66_CPU': {
    ko: 'CPU 시간',
    ja: 'CPU時間',
    en: 'CPU time',
    cn: '',
  },
  'insprpt.label.RPT_WP66_TIME': {
    ko: '처리시간',
    ja: '処理時間',
    en: 'Time',
    cn: '',
  },
  'insprpt.label.RPT_WP66_PROGRAM': {
    ko: '프로그램',
    ja: 'プログラム',
    en: 'Program',
    cn: '',
  },
  'insprpt.label.RPT_WP66_CLIENT': {
    ko: '클라이언트',
    ja: 'クライアント',
    en: 'Client',
    cn: '',
  },
  'insprpt.label.RPT_WP66_USER': {
    ko: '사용자ID',
    ja: 'ユーザーID',
    en: 'User',
    cn: '',
  },
  'insprpt.label.RPT_WP66_ACTION': {
    ko: '현재 액션',
    ja: '現在アクション',
    en: 'Action',
    cn: '',
  },
  'insprpt.label.RPT_WP66_ACTIONINFO': {
    ko: '현재 액션 정보',
    ja: '現在アクション情報',
    en: 'Action info',
    cn: '',
  },
  'insprpt.label.RPT_WP66_MORE': {
    ko: '외 (표시 상한 초과)',
    ja: 'ほか (表示上限超過)',
    en: 'more (limit exceeded)',
    cn: '',
  },
  // 인터페이스 오류 확인(CBO, ZCML3010 / FM ZCMF_IF_SEND_OWL) 상세 라벨 — 정의서 CM_SAPOWL_0001 RES 필드(SEQ 5~21, MANDT 제외)
  'insprpt.label.RPT_IF_IF_ID': {
    ko: 'I/F ID',
    ja: 'I/F ID',
    en: 'I/F ID',
    cn: '',
  },
  'insprpt.label.RPT_IF_IF_ID_NM': {
    ko: 'I/F 명',
    ja: 'I/F 名',
    en: 'I/F name',
    cn: '',
  },
  'insprpt.label.RPT_IF_SYSID': {
    ko: 'I/F Unique ID',
    ja: 'I/F Unique ID',
    en: 'I/F unique ID',
    cn: '',
  },
  'insprpt.label.RPT_IF_IF_DATE': {
    ko: '호출/응답 시각',
    ja: '呼出/応答時刻',
    en: 'Call/respond time',
    cn: '',
  },
  'insprpt.label.RPT_IF_STATUS': {
    ko: 'I/F 상태',
    ja: 'I/F 状態',
    en: 'I/F status',
    cn: '',
  },
  'insprpt.label.RPT_IF_RMTYPE': {
    ko: 'Remote 유형',
    ja: 'Remoteタイプ',
    en: 'Remote type',
    cn: '',
  },
  'insprpt.label.RPT_IF_EAIMO': {
    ko: '업무코드',
    ja: '業務コード',
    en: 'Task code',
    cn: '',
  },
  'insprpt.label.RPT_IF_SYSCD_S': {
    ko: '송신 시스템코드',
    ja: '送信システムコード',
    en: 'Sender system code',
    cn: '',
  },
  'insprpt.label.RPT_IF_SYSCD_T': {
    ko: '수신 시스템코드',
    ja: '受信システムコード',
    en: 'Receiver system code',
    cn: '',
  },
  'insprpt.label.RPT_IF_IF_EXTRA': {
    ko: '예비필드',
    ja: '予備フィールド',
    en: 'Reserve field',
    cn: '',
  },
  'insprpt.label.RPT_IF_IF_RESULT': {
    ko: 'EAI 리턴코드',
    ja: 'EAIリターンコード',
    en: 'EAI return code',
    cn: '',
  },
  'insprpt.label.RPT_IF_IF_MSG': {
    ko: '결과 메시지',
    ja: '結果メッセージ',
    en: 'Result message',
    cn: '',
  },
  'insprpt.label.RPT_IF_NOTICE': {
    ko: '정보',
    ja: '情報',
    en: 'Notice',
    cn: '',
  },
  'insprpt.label.RPT_IF_RETCD': {
    ko: '메시지 유형',
    ja: 'メッセージタイプ',
    en: 'Message type',
    cn: '',
  },
  'insprpt.label.RPT_IF_RETMG': {
    ko: '메시지 텍스트',
    ja: 'メッセージテキスト',
    en: 'Message text',
    cn: '',
  },
  'insprpt.label.RPT_IF_ZERZET': {
    ko: '입력시간',
    ja: '入力時間',
    en: 'Created time',
    cn: '',
  },
  'insprpt.label.RPT_IF_ZERDAT': {
    ko: '레코드 생성일',
    ja: 'レコード生成日',
    en: 'Record created date',
    cn: '',
  },
  'insprpt.label.RPT_IF_ERROR_CNT': {
    ko: '오류 건수',
    ja: 'エラー件数',
    en: 'Error count',
    cn: '',
  },
  'insprpt.label.RPT_IF_MORE': {
    ko: '외 (표시 상한 초과)',
    ja: 'ほか (表示上限超過)',
    en: 'more (limit exceeded)',
    cn: '',
  },
  // 전자결재 후속처리 오류 확인(CBO, ZCML2020 / FM ZCMF_WF_SEND_OWL) 상세 라벨 — 정의서 CM_SAPOWL_0002 RES 필드(SEQ 5~23, MANDT 제외)
  'insprpt.label.RPT_APPR_WFOBJECT': {
    ko: '결재업무분류',
    ja: '決裁業務分類',
    en: 'Approval task type',
    cn: '',
  },
  'insprpt.label.RPT_APPR_WFOBJECT_NM': {
    ko: 'W/F 오브젝트명',
    ja: 'W/Fオブジェクト名',
    en: 'W/F object name',
    cn: '',
  },
  'insprpt.label.RPT_APPR_OBJECTID': {
    ko: 'W/F Key',
    ja: 'W/F Key',
    en: 'W/F key',
    cn: '',
  },
  'insprpt.label.RPT_APPR_WFSTATUS': {
    ko: '결재상태',
    ja: '決裁状態',
    en: 'Approval status',
    cn: '',
  },
  'insprpt.label.RPT_APPR_PROCESSID': {
    ko: '문서 ID',
    ja: '文書ID',
    en: 'Document ID',
    cn: '',
  },
  'insprpt.label.RPT_APPR_EMP_ID': {
    ko: '상신자 ID',
    ja: '起案者ID',
    en: 'Requester ID',
    cn: '',
  },
  'insprpt.label.RPT_APPR_EMPID_NM': {
    ko: '상신자명',
    ja: '起案者名',
    en: 'Requester name',
    cn: '',
  },
  'insprpt.label.RPT_APPR_USRID2': {
    ko: '승인자 ID',
    ja: '承認者ID',
    en: 'Approver ID',
    cn: '',
  },
  'insprpt.label.RPT_APPR_USRID3': {
    ko: '기안취소 ID',
    ja: '起案取消ID',
    en: 'Cancel ID',
    cn: '',
  },
  'insprpt.label.RPT_APPR_USRID4': {
    ko: '반려자 ID',
    ja: '差戻者ID',
    en: 'Rejecter ID',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZMODULE': {
    ko: '모듈',
    ja: 'モジュール',
    en: 'Module',
    cn: '',
  },
  'insprpt.label.RPT_APPR_RETCD': {
    ko: '오류코드',
    ja: 'エラーコード',
    en: 'Return code',
    cn: '',
  },
  'insprpt.label.RPT_APPR_RETMG': {
    ko: '오류 메시지',
    ja: 'エラーメッセージ',
    en: 'Return message',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZERZET': {
    ko: '입력시간',
    ja: '入力時間',
    en: 'Created time',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZERDAT': {
    ko: '입력일',
    ja: '入力日',
    en: 'Created date',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZERNAM': {
    ko: '입력자',
    ja: '入力者',
    en: 'Created by',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZAEZET': {
    ko: '변경시간',
    ja: '変更時間',
    en: 'Changed time',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZAEDAT': {
    ko: '변경일',
    ja: '変更日',
    en: 'Changed date',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ZAENAM': {
    ko: '변경자',
    ja: '変更者',
    en: 'Changed by',
    cn: '',
  },
  'insprpt.label.RPT_APPR_ERROR_CNT': {
    ko: '오류 건수',
    ja: 'エラー件数',
    en: 'Error count',
    cn: '',
  },
  'insprpt.label.RPT_APPR_MORE': {
    ko: '외 (표시 상한 초과)',
    ja: 'ほか (表示上限超過)',
    en: 'more (limit exceeded)',
    cn: '',
  },
  // DB02 Alert 점검(HANA _SYS_STATISTICS.STATISTICS_CURRENT_ALERTS) 상세 라벨
  'insprpt.label.RPT_DBALERT_PRIORITY': {
    ko: 'Max priority',
    ja: 'Max priority',
    en: 'Max priority',
    cn: '',
  },
  'insprpt.label.RPT_DBALERT_NAME': {
    ko: 'Alert Name',
    ja: 'Alert Name',
    en: 'Alert Name',
    cn: '',
  },
  'insprpt.label.RPT_DBALERT_DESC': {
    ko: 'Description',
    ja: 'Description',
    en: 'Description',
    cn: '',
  },
  'insprpt.label.RPT_DBALERT_CNT': {
    ko: '알림 건수',
    ja: 'アラート件数',
    en: 'Alert count',
    cn: '',
  },
  'insprpt.label.RPT_DBALERT_MORE': {
    ko: '외 (표시 상한 초과)',
    ja: 'ほか (表示上限超過)',
    en: 'more (limit exceeded)',
    cn: '',
  },
  // 결과 0건(조회된 데이터 없음) 공용 표기 — 각 점검 항목의 빈 결과 시 그리드 detail 에 표시
  'insprpt.label.RPT_NO_DATA': {
    ko: '데이터가 없습니다.',
    ja: 'データがありません。',
    en: 'No data available.',
    cn: '',
  },
  // FINISH::Added.by.HJSeo.2026.07.02.
  'insprpt.label.RPT_SYSLOG_TIME': {
    ko: 'Time',
    ja: 'Time',
    en: 'Time',
    cn: '',
  },
  'insprpt.label.RPT_SYSLOG_PRIORITY': {
    ko: 'Priority',
    ja: 'Priority',
    en: 'Priority',
    cn: '',
  },
  'insprpt.label.RPT_SYSLOG_TYPE': {
    ko: 'Type',
    ja: 'Type',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_SYSLOG_TEXT': {
    ko: 'Text',
    ja: 'Text',
    en: 'Text',
    cn: '',
  },
  'insprpt.label.RPT_SYSLOG_CNT': {
    ko: '오류/경고 건수',
    ja: 'エラー/警告件数',
    en: 'Error/Warning count',
    cn: '',
  },
  'insprpt.label.RPT_SYSLOG_MORE': {
    ko: '상한 초과(이하 생략)',
    ja: '上限超過(以下省略)',
    en: 'Truncated (limit reached)',
    cn: '',
  },
  'insprpt.label.RPT_LOGON_DUP_CNT': {
    ko: 'Logon Dup.(cnt)',
    ja: 'Logon Dup.(cnt)',
    en: 'Logon Dup.(cnt)',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_USER': {
    ko: 'User',
    ja: 'User',
    en: 'User',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_OBJECT': {
    ko: '락 객체',
    ja: 'ロックオブジェクト',
    en: 'Lock object',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_ARG': {
    ko: '락 인자',
    ja: 'ロック引数',
    en: 'Lock argument',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_CLIENT': {
    ko: 'Client',
    ja: 'Client',
    en: 'Client',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_TIME': {
    ko: '설정시각',
    ja: '設定時刻',
    en: 'Time',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_MODE': {
    ko: 'Mode',
    ja: 'Mode',
    en: 'Mode',
    cn: '',
  },
  'insprpt.label.RPT_ENQ_CNT': {
    ko: '락 건수',
    ja: 'ロック件数',
    en: 'Lock count',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_RUNTIME': {
    ko: 'Runtime Errors',
    ja: 'Runtime Errors',
    en: 'Runtime Errors',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_SHORTTEXT': {
    ko: 'Short Text',
    ja: 'Short Text',
    en: 'Short Text',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_EXC': {
    ko: 'Except.',
    ja: 'Except.',
    en: 'Except.',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_PROGRAM': {
    ko: 'ABAP: Program',
    ja: 'ABAP: Program',
    en: 'ABAP: Program',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_USER': {
    ko: 'User',
    ja: 'User',
    en: 'User',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_TXN': {
    ko: 'Transaction',
    ja: 'Transaction',
    en: 'Transaction',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_CNT': {
    ko: 'Dump 건수',
    ja: 'Dump件数',
    en: 'Dump count',
    cn: '',
  },
  'insprpt.label.RPT_DUMP_MORE': {
    ko: '상한 초과(이하 생략)',
    ja: '上限超過(以下省略)',
    en: 'Truncated (limit reached)',
    cn: '',
  },
  'insprpt.label.RPT_WL_STEPS': {
    ko: '# Steps',
    ja: '# Steps',
    en: '# Steps',
    cn: '',
  },
  'insprpt.label.RPT_WL_RESP': {
    ko: '응답시간(µs)',
    ja: '応答時間(µs)',
    en: 'Ø Time (µs)',
    cn: '',
  },
  'insprpt.label.RPT_WL_CPU': {
    ko: 'CPU 시간(µs)',
    ja: 'CPU時間(µs)',
    en: 'Ø CPU Time (µs)',
    cn: '',
  },
  'insprpt.label.RPT_WL_DB': {
    ko: 'DB 시간(µs)',
    ja: 'DB時間(µs)',
    en: 'Ø DB Time (µs)',
    cn: '',
  },
  'insprpt.label.RPT_BUF_NAME': {
    ko: 'Buffer',
    ja: 'Buffer',
    en: 'Buffer',
    cn: '',
  },
  'insprpt.label.RPT_BUF_SWAPS': {
    ko: 'Swaps',
    ja: 'Swaps',
    en: 'Swaps',
    cn: '',
  },
  'insprpt.label.RPT_BUF_HITRATIO': {
    ko: 'HitRatio (%)',
    ja: 'HitRatio (%)',
    en: 'HitRatio (%)',
    cn: '',
  },
  'insprpt.label.RPT_BUF_FREESP': {
    ko: 'Free Space (KB)',
    ja: 'Free Space (KB)',
    en: 'Free Space (KB)',
    cn: '',
  },
  'insprpt.label.RPT_BUF_FREEDIR': {
    ko: 'Free Dir',
    ja: 'Free Dir',
    en: 'Free Dir',
    cn: '',
  },
  'insprpt.label.RPT_BUF_ALLOC': {
    ko: 'Alloc. KB',
    ja: 'Alloc. KB',
    en: 'Alloc. KB',
    cn: '',
  },
  'insprpt.label.RPT_BUF_SWAP_CNT': {
    ko: '스왑 발생 버퍼 수',
    ja: 'スワップ発生バッファ数',
    en: 'Swapping buffers',
    cn: '',
  },
  'insprpt.label.RPT_APPLOG_ERR_CNT': {
    ko: '에러 건수',
    ja: 'エラー件数',
    en: 'Error count',
    cn: '',
  },
  'insprpt.label.RPT_DB_SPACE': {
    ko: 'Space (%)',
    ja: 'Space (%)',
    en: 'Space (%)',
    cn: '',
  },
  'insprpt.label.RPT_DB_MEMORY': {
    ko: 'Memory (%)',
    ja: 'Memory (%)',
    en: 'Memory (%)',
    cn: '',
  },
  'insprpt.label.RPT_DB_TBLSPACE': {
    ko: 'Table Space (%)',
    ja: 'Table Space (%)',
    en: 'Table Space (%)',
    cn: '',
  },
  // BEGIN::Added.by.HJSeo.2026.07.20. Weekly 점검 상세 라벨(Available Memory / Database Growth / File System Usage)
  'insprpt.label.RPT_DB_AVAIL_MEM': {
    ko: '여유 메모리 (GB)',
    ja: '空きメモリ (GB)',
    en: 'Available Memory (GB)',
    cn: '',
  },
  'insprpt.label.RPT_DB_AVAIL_SPACE': {
    ko: '여유 공간 (GB)',
    ja: '空き容量 (GB)',
    en: 'Available Space (GB)',
    cn: '',
  },
  'insprpt.label.RPT_DB_GROWTH_BASE': {
    ko: '이전 사용량 (GB)',
    ja: '前回使用量 (GB)',
    en: 'Previous Used (GB)',
    cn: '',
  },
  'insprpt.label.RPT_DB_GROWTH_CURR': {
    ko: '현재 사용량 (GB)',
    ja: '現在使用量 (GB)',
    en: 'Current Used (GB)',
    cn: '',
  },
  'insprpt.label.RPT_DB_GROWTH_DIFF': {
    ko: '증가량 (GB)',
    ja: '増加量 (GB)',
    en: 'Growth (GB)',
    cn: '',
  },
  'insprpt.label.RPT_DB_GROWTH_RATE': {
    ko: '증가율 (%)',
    ja: '増加率 (%)',
    en: 'Growth Rate (%)',
    cn: '',
  },
  // File System Usage 상세는 'Operation System > File System'(G_ABAP_OS_FSYS) 그리드 헤더명과 일치시킨다.
  // OS 화면은 값에 단위(MB)를 붙이지만 체크리스트 값은 GB 라, 혼동 방지로 헤더에 단위를 괄호로 표기.
  'insprpt.label.RPT_FSYS_NAME': {
    ko: 'File system name',
    ja: 'File system name',
    en: 'File system name',
    cn: '',
  },
  'insprpt.label.RPT_FSYS_SIZE': {
    ko: 'Size (GB)',
    ja: 'Size (GB)',
    en: 'Size (GB)',
    cn: '',
  },
  'insprpt.label.RPT_FSYS_FREE': {
    ko: 'Available (GB)',
    ja: 'Available (GB)',
    en: 'Available (GB)',
    cn: '',
  },
  'insprpt.label.RPT_FSYS_USED_RATE': {
    ko: 'Used rate (%)',
    ja: 'Used rate (%)',
    en: 'Used rate (%)',
    cn: '',
  },
  'insprpt.label.RPT_FSYS_CNT': {
    ko: '파일시스템 수',
    ja: 'ファイルシステム数',
    en: 'File System Count',
    cn: '',
  },
  // FINISH::Added.by.HJSeo.2026.07.20.
  // BEGIN::Added.by.HJSeo.2026.07.22. User Security(SU01, Quarterly) 상세 라벨.
  'insprpt.label.RPT_USER_ID': {
    ko: '사용자 ID',
    ja: 'ユーザーID',
    en: 'User ID',
    cn: '',
  },
  'insprpt.label.RPT_USER_TYPE': {
    ko: '유형',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_USER_LASTLOGON': {
    ko: '마지막 로그온',
    ja: '最終ログオン',
    en: 'Last Logon',
    cn: '',
  },
  'insprpt.label.RPT_USER_VALIDTO': {
    ko: '유효 종료일',
    ja: '有効終了日',
    en: 'Valid To',
    cn: '',
  },
  'insprpt.label.RPT_USER_LOCK': {
    ko: '잠금 상태',
    ja: 'ロック状態',
    en: 'Lock Status',
    cn: '',
  },
  'insprpt.label.RPT_USER_REASON': {
    ko: '검토 사유',
    ja: '確認理由',
    en: 'Review Reason',
    cn: '',
  },
  'insprpt.label.RPT_USER_REVIEW_CNT': {
    ko: '검토 대상 수',
    ja: '確認対象数',
    en: 'Review Count',
    cn: '',
  },
  // Scheduled Job(SM37, Quarterly) 상세 라벨. 용어는 Batch Job 화면(dv.field.*)과 일치시킨다.
  'insprpt.label.RPT_JOB_NAME': {
    ko: '배치잡 명',
    ja: 'バッチジョブ名',
    en: 'Job name',
    cn: '',
  },
  'insprpt.label.RPT_JOB_OWNER': {
    ko: '생성자',
    ja: '作成者',
    en: 'Creator',
    cn: '',
  },
  'insprpt.label.RPT_JOB_STATUS': {
    ko: '상태',
    ja: 'ステータス',
    en: 'Status',
    cn: '',
  },
  'insprpt.label.RPT_JOB_LASTSTRT': {
    ko: '마지막 실행',
    ja: '最終実行',
    en: 'Last Start',
    cn: '',
  },
  'insprpt.label.RPT_JOB_REASON': {
    ko: '검토 사유',
    ja: '確認理由',
    en: 'Review Reason',
    cn: '',
  },
  'insprpt.label.RPT_JOB_REVIEW_CNT': {
    ko: '검토 대상 수',
    ja: '確認対象数',
    en: 'Review Count',
    cn: '',
  },
  // FINISH::Added.by.HJSeo.2026.07.22.
  // BEGIN::Added.by.HJSeo.2026.07.23. Authorization Roles(PFCG, Annual) 상세 라벨.
  'insprpt.label.RPT_ROLE_NAME': {
    ko: '역할명',
    ja: 'ロール名',
    en: 'Role name',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_TYPE': {
    ko: '유형',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_TEXT': {
    ko: '설명',
    ja: '説明',
    en: 'Description',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_CREATE_DATIM': {
    ko: '생성일시',
    ja: '作成日時',
    en: 'Created on',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_CHANGE_DATIM': {
    ko: '변경일시',
    ja: '変更日時',
    en: 'Changed on',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_TCODE_CNT': {
    ko: 'T-Code 수',
    ja: 'Tコード数',
    en: 'T-code Count',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_UNUSED_CNT': {
    ko: '미사용 역할 수',
    ja: '未使用ロール数',
    en: 'Unused Role Count',
    cn: '',
  },
  'insprpt.label.RPT_ROLE_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // Profiles(SU02, Annual) 상세 라벨.
  'insprpt.label.RPT_PRFL_NAME': {
    ko: '프로필명',
    ja: 'プロファイル名',
    en: 'Profile name',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_TYPE': {
    ko: '유형',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_TEXT': {
    ko: '설명',
    ja: '説明',
    en: 'Description',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_CHANGE_DATIM': {
    ko: '변경일시',
    ja: '変更日時',
    en: 'Changed on',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_TCODE_CNT': {
    ko: 'T-Code 수',
    ja: 'Tコード数',
    en: 'T-code Count',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_UNUSED_CNT': {
    ko: '미사용 프로필 수',
    ja: '未使用プロファイル数',
    en: 'Unused Profile Count',
    cn: '',
  },
  'insprpt.label.RPT_PRFL_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // Authorizations(SU03, Annual) 상세 라벨.
  'insprpt.label.RPT_AUTH_USER': {
    ko: '사용자 ID',
    ja: 'ユーザーID',
    en: 'User ID',
    cn: '',
  },
  'insprpt.label.RPT_AUTH_PROFILE': {
    ko: '프로필',
    ja: 'プロファイル',
    en: 'Profile',
    cn: '',
  },
  'insprpt.label.RPT_AUTH_CHANGE_DATIM': {
    ko: '부여일시',
    ja: '付与日時',
    en: 'Granted on',
    cn: '',
  },
  'insprpt.label.RPT_AUTH_CRIT_CNT': {
    ko: '위험 권한 보유 수',
    ja: '危険権限保有数',
    en: 'Critical Auth Count',
    cn: '',
  },
  'insprpt.label.RPT_AUTH_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // SoD(직무 분리 위배, Annual) 상세 라벨. 화면(SoD & RA) 용어와 정렬: 매트릭스 / 위험 수준 / 위배.
  'insprpt.label.RPT_SOD_USER': {
    ko: '사용자 ID',
    ja: 'ユーザーID',
    en: 'User ID',
    cn: '',
  },
  'insprpt.label.RPT_SOD_MATRIX': {
    ko: 'SoD 매트릭스',
    ja: 'SoDマトリックス',
    en: 'SoD Matrix',
    cn: '',
  },
  'insprpt.label.RPT_SOD_RISK': {
    ko: '위험 수준',
    ja: 'リスクレベル',
    en: 'Risk Level',
    cn: '',
  },
  'insprpt.label.RPT_SOD_ROLE': {
    ko: '원인 역할',
    ja: '原因ロール',
    en: 'Conflicting Roles',
    cn: '',
  },
  'insprpt.label.RPT_SOD_VLTN_CNT': {
    ko: '위배 사용자 수',
    ja: '違反ユーザー数',
    en: 'Violation User Count',
    cn: '',
  },
  'insprpt.label.RPT_SOD_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // RA(접근 제한 위배, Annual) 상세 라벨. 화면(SoD & RA)의 RA 탭과 정렬: RA 규칙 / 위험 수준 / 위험 유형(권한객체·프로파일).
  'insprpt.label.RPT_RA_USER': {
    ko: '사용자 ID',
    ja: 'ユーザーID',
    en: 'User ID',
    cn: '',
  },
  'insprpt.label.RPT_RA_RULE': {
    ko: '접근 제한 규칙',
    ja: 'アクセス制限ルール',
    en: 'Restricted Access Rule',
    cn: '',
  },
  'insprpt.label.RPT_RA_RISK': {
    ko: '위험 수준',
    ja: 'リスクレベル',
    en: 'Risk Level',
    cn: '',
  },
  'insprpt.label.RPT_RA_TYPE': {
    ko: '위험 유형',
    ja: 'リスクタイプ',
    en: 'Risk Type',
    cn: '',
  },
  'insprpt.label.RPT_RA_ROLE': {
    ko: '원인 역할',
    ja: '原因ロール',
    en: 'Conflicting Roles',
    cn: '',
  },
  'insprpt.label.RPT_RA_VLTN_CNT': {
    ko: '위배 사용자 수',
    ja: '違反ユーザー数',
    en: 'Violation User Count',
    cn: '',
  },
  'insprpt.label.RPT_RA_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // 표준계정(SAP*/DDIC, Annual) 상세 라벨.
  'insprpt.label.RPT_STD_USER': {
    ko: '계정',
    ja: 'アカウント',
    en: 'Account',
    cn: '',
  },
  'insprpt.label.RPT_STD_TYPE': {
    ko: '유형',
    ja: 'タイプ',
    en: 'Type',
    cn: '',
  },
  'insprpt.label.RPT_STD_LOCK': {
    ko: '잠금 상태',
    ja: 'ロック状態',
    en: 'Lock Status',
    cn: '',
  },
  'insprpt.label.RPT_STD_PWDSTATE': {
    ko: '비밀번호 상태',
    ja: 'パスワード状態',
    en: 'Password Status',
    cn: '',
  },
  'insprpt.label.RPT_STD_LASTLOGON': {
    ko: '마지막 로그온',
    ja: '最終ログオン',
    en: 'Last Logon',
    cn: '',
  },
  'insprpt.label.RPT_STD_REASON': {
    ko: '검토 사유',
    ja: '確認事由',
    en: 'Review Reason',
    cn: '',
  },
  'insprpt.label.RPT_STD_REVIEW_CNT': {
    ko: '검토 대상 수',
    ja: '確認対象数',
    en: 'Review Count',
    cn: '',
  },
  'insprpt.label.RPT_STD_NOTE': {
    ko: '안내',
    ja: 'お知らせ',
    en: 'Note',
    cn: '',
  },
  // FINISH::Added.by.HJSeo.2026.07.23.
  'insprpt.more': {
    ko: '더보기',
    ja: 'もっと見る',
    en: 'More',
    cn: '',
  },
  'insprpt.empty.data': {
    ko: '점검 결과가 없습니다.',
    ja: '点検結果がありません。',
    en: 'No inspection results.',
    cn: '',
  },
  'insprpt.msg.no.system': {
    ko: '시스템을 먼저 선택하세요.',
    ja: 'システムを先に選択してください。',
    en: 'Please select a system first.',
    cn: '',
  },
  'insprpt.msg.check.q': {
    ko: '점검을 실행하시겠습니까?',
    ja: '点検を実行しますか？',
    en: 'Are you sure you want to run the inspection?',
    cn: '',
  },
  'insprpt.msg.check.done': {
    ko: '점검을 실행했습니다. (chk_id: {id})',
    ja: '点検を実行しました。(chk_id: {id})',
    en: 'Inspection executed. (chk_id: {id})',
    cn: '',
  },
  'insprpt.msg.check.fail': {
    ko: '점검 실행에 실패했습니다.',
    ja: '点検の実行に失敗しました。',
    en: 'Failed to execute inspection.',
    cn: '',
  },
  // 점검 + 리포트 메일 발송(LEM 화면 전용. 표준 화면은 위 insprpt.msg.check.* 를 그대로 사용)
  'insprpt.msg.check.mail.q': {
    ko: '점검을 실행하고 결과 리포트를 메일로 발송합니다. 진행하시겠습니까?',
    ja: '点検を実行し、結果レポートをメールで送信します。続行しますか？',
    en: 'The inspection will run and the report will be sent by email. Continue?',
    cn: '',
  },
  'insprpt.msg.check.mail.done': {
    ko: '점검을 실행하고 리포트 메일을 발송했습니다. (chk_id: {id})',
    ja: '点検を実行し、レポートメールを送信しました。(chk_id: {id})',
    en: 'Inspection executed and the report email was sent. (chk_id: {id})',
    cn: '',
  },
  'insprpt.msg.check.mail.skip': {
    ko: '점검을 실행했습니다. 수신자 또는 메일 설정이 없어 메일은 발송되지 않았습니다. (chk_id: {id})',
    ja: '点検を実行しました。受信者またはメール設定がないため、メールは送信されませんでした。(chk_id: {id})',
    en: 'Inspection executed. No email was sent (no recipients or mail not configured). (chk_id: {id})',
    cn: '',
  },
  'insprpt.msg.check.mail.fail': {
    ko: '점검은 실행했으나 리포트 메일 발송에 실패했습니다. (chk_id: {id})',
    ja: '点検は実行しましたが、レポートメールの送信に失敗しました。(chk_id: {id})',
    en: 'Inspection executed, but sending the report email failed. (chk_id: {id})',
    cn: '',
  },
  // 점검 항목 설정 팝업
  'insprpt.cfg.title': {
    ko: '점검 항목 설정',
    ja: '点検項目設定',
    en: 'Check Item Settings',
    cn: '',
  },
  'insprpt.cfg.col.active': {
    ko: '점검',
    ja: '点検',
    en: 'Check',
    cn: '',
  },
  'insprpt.cfg.col.dspl': {
    ko: '표시',
    ja: '表示',
    en: 'Display',
    cn: '',
  },
  'insprpt.cfg.msg.saved': {
    ko: '설정을 저장했습니다.',
    ja: '設定を保存しました。',
    en: 'Settings saved.',
    cn: '',
  },
  'insprpt.cfg.msg.fail': {
    ko: '설정 저장에 실패했습니다.',
    ja: '設定の保存に失敗しました。',
    en: 'Failed to save settings.',
    cn: '',
  },
  // Excel 내보내기
  'insprpt.excel.sheet.grid': {
    ko: 'checklist',
    ja: 'checklist',
    en: 'checklist',
    cn: 'checklist',
  },
  'insprpt.msg.excel.fail': {
    ko: 'Excel 내보내기에 실패했습니다.',
    ja: 'Excelのエクスポートに失敗しました。',
    en: 'Failed to export Excel.',
    cn: '',
  },
};
// FINISH::Added.by.HJSeo.2026.06.19.
